// extracted by mini-css-extract-plugin
export default {"pagina_conteudo":"NovoSistema_pagina_conteudo__w2QgR"};